export default {
	install(options) {
		const locale = options.locale || 'votre_locale_par_defaut'
		let id = locale === 'jp' ? 'ULLPTg' : 'UBN4LK'
		const script = document.createElement('script')
		script.type = 'text/javascript'
		script.async = true
		script.src = `https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=${id}`
		document.head.appendChild(script)
	}
}
